export default __webpack_public_path__ + "static/media/logo2.63c4d630.svg";